import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { Status } from 'src/app/shared/models/general.model';
import { TransitServicePenaltyDTO } from '../shared/models/transit-service-penalty.model';

export class TransitRequestDto {
    Id: string
    RequestNumber: string;
    AgentName: string;
    StatusId: number;
    Status: Status;
    D_FWD: string
    D_AFT: string;
    AirDraught: string
    Anchors: string;
    ShipsCranes: string;
    Class: string
    BuildingDate: Date;
    LastName: string;
    LastFlagId: number;
    baseRequest: BaseRequest;
    Extensions: string;
    FloatingUnits: string;
    IMONO: string
    MaxManouveringSpeed: string;
    RegisteryCertificateDate: Date;
    SecurityLevelId: number
    PropellerType: string;
    ActualTransitDate: Date;
    ArrivalDateTime: Date;
    Requirements: string;
    IsDeleted: boolean;
    IsArrived: boolean;
    IsCancelled: boolean;
    IsConfirmedPayment: boolean;
    SecurityLevel: GenericLookup = new GenericLookup();
    Nationality: GenericLookup = new GenericLookup();
    RequestorId: string;
    FeesRequestId: string;
    // Added in Ebooking-Revamp
    TransitType: number;
    IsRadioActive: boolean = false;
    IsCarryingAnimals: boolean;
    AgentTransitDate: Date;
    AgentETA: Date;
    AgentLastTransitDate: Date;
    IsEstimatedFeesPaid?: boolean;
    PaymentStatus?: boolean;
    IsPaymentRefunded?: boolean;
    IsVesselTransited?: boolean;
    LimitTimeRate?: number;
    Direction?: number;
    LatestStepId?: number;
    TransitServicePenalties: TransitServicePenaltyDTO[] = [];
    /* Removed in Ebooking-Revamp */

    IsPendingDocument: boolean;
    DocuemntName: string;
    IsAgentPayedTotal: boolean;
    IsAgentPayedFirst: boolean;
    ExtraFee: string;
    HasMeasureExtraFee: boolean;
    MeasureExtraFee: string;
    ChequeNumber: string;
    IsFirstConfirmedPayment: boolean;
    IsTotalConfirmedPayment: boolean;
    MeasurementDescription: string;
    CreatedBy:string;
    CreationDate:Date;


    /* ------------------------ */
}
